var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecraft = function SvgRecraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    className: "recraft_svg__fill-black recraft_svg__dark:fill-white recraft_svg__pointer-events-none recraft_svg__size-4 recraft_svg__select-none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      flex: "0 0 auto",
      lineHeight: 1
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 8.275c0-4.57-4.15-8.275-9.27-8.275-1.774 0-3.213 3.705-3.213 8.275 0 1.143.09 2.233.253 3.224H4.29L1 23h9.4v-6.447c5.117 0 9.266-3.707 9.266-8.275l.001-.002zm-9.27-6.76c.93 0 1.682 3.028 1.682 6.76 0 3.733-.752 6.76-1.681 6.76-.93 0-1.681-3.027-1.681-6.76 0-3.732.752-6.76 1.68-6.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.848 16.552h-9.44L14.028 23h9.438l-3.618-6.448z"
  })));
};
export default SvgRecraft;